// extracted by mini-css-extract-plugin
export default {"input":"CheckBox_input__AAEs+","icon":"CheckBox_icon__VLxhT"};